import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import {
  ScheduledReportRoute,
  ScheduledReportPathName,
} from '@/modules/ta/scheduledreport/scheduledreport.constant';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${ScheduledReportRoute.SCHEDULEDREPORTS}`,
      name: ScheduledReportPathName.SCHEDULEDREPORTS,
      component: () =>
        import(/* webpackChunkName: "scheduledreports-page" */ './pages/ScheduledReportsPage.vue'),
    },
    {
      path: `/${ScheduledReportRoute.SCHEDULEDREPORTS}/new`,
      name: ScheduledReportPathName.SCHEDULEDREPORTS_NEW,
      component: () =>
        import(
          /* webpackChunkName: "scheduledreports-form-page" */ './pages/ScheduledReportFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${ScheduledReportRoute.SCHEDULEDREPORTS}/:id`,
      name: ScheduledReportPathName.SCHEDULEDREPORTFORM,
      component: () =>
        import(
          /* webpackChunkName: "scheduledreport-form-page" */ './pages/ScheduledReportFormPage.vue'
        ),
      props: true,
    },
  ],
  Module.SCHEDULEDREPORT
);
